<template>
  <div class="ins009">
    <div><modals-container @registBoard="registBoard"></modals-container></div>
    <div class="mypage-header">
      <div class="inner">
        <h3>{{ $i18nUtil.trans("title.CooperationMemberBoard.001", "공유받은 보드") }} 
          <span>{{ $i18nUtil.trans("message.CooperationMemberBoard.001","멤버가 아닌 과제나 프라이빗 공간의 비공개 보드를 확인해보세요.") }}</span>
        </h3>
      </div>
    </div><!-- //mypage-header -->

    <div class="mypage_cnt">
      <div class="file-wrap clear">
        <div class="tb-list_ty1">
          <div class="tb-header clear">
            <div class="tb_num fl">
              <!-- <input type="checkbox" name="" id="name1"> -->
              <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalElements})"></div>
              <!-- 검색 조회시 노출 S -->
              <div class="check_result" v-show="showSearchBoardTitle">
                <div class="txt" v-html="$i18nUtil.trans('search.000.result.paperTitle', '보드명 “{search}” 검색 결과 총 <b>{cnt}</b> 건', {search: rtnSearchPaperTitle, cnt: totalElements})"></div>
                <button type="button" @click="clearSearchPaperTitle">초기화</button>
              </div>
              <!-- //검색 조회시 노출 E -->
            </div>

            <div class="tb_sort fr">
                <input type="checkbox" name="" id="new" v-model="isReadFilter" @change="fireFilterRead"><label for="new">{{ $i18nUtil.trans("button.paper.unread", "미확인 보드 보기") }}</label>
                <input type="checkbox" name="" id="chkBookmarkFilter" v-model="isBookmarkFilter" @change="fireFilterBookmark"><label for="chkBookmarkFilter">{{ $i18nUtil.trans("button.favorite", "즐겨찾기 보기") }}</label>
                <div class="dividing_line_ty1"></div>
                <div class="search_ty2">
                    <button type="button" class="search-show" @click="isSearchArea = true" :class="isSearchArea ? 'active' : ''">검색</button>
                    <form action="" @submit.stop onsubmit="return false;" class="search-show">
                      <div class="input-box">
                          <input type="text" 
                            class="search-show" 
                            :class="searchPaperTitle == '' ? 'ico_search' : ''" 
                            v-model="searchPaperTitle" 
                            @keyup.enter="getCooperationMemberBoardList(true)"
                            :placeholder="$i18nUtil.trans('message.CooperationMemberBoard.002','보드명 검색')"
                            @focus="$event.target.placeholder=''"
                            @focusout="$event.target.placeholder=$i18nUtil.trans('message.CooperationMemberBoard.002','보드명 검색')"
                            maxlength="21"
                          />
                          <button type="reset" 
                            class="input-txt-del search-show" 
                            @click="searchPaperTitle = ''" 
                            v-if="searchPaperTitle != ''"
                          >
                            입력 삭제
                          </button>
                          <button type="reset" 
                            class="btn_search search-show" 
                            @click="getCooperationMemberBoardList(true)"
                          >
                            검색
                          </button>
                      </div>
                    </form>
                </div>
                <CooperationMemberBoardFilter :filterReset="filterReset" @updateCooperationMemberBoardFilter="updateCooperationMemberBoardFilter" />
            </div>
          </div><!-- //tb-header -->

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="boardList"
            :page.sync="page"
            :must-sort="true"
            :items-per-page="itemsPerPage"
            :server-items-length="totalElements"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            hide-default-footer
            class="tb-contents">

            <template v-slot:item="{ item }">
              <tr :class="item.isState">
                <td class="division">
                  <div type="button" :class="getEvaluateClassAndText(item).evaluateClass">
                    {{getEvaluateClassAndText(item).evaluateText}}
                  </div>
                  <div class="subject multi-ellipsis" @click="goBoard(item.paperId)">
                    {{ item.paperTitle }}
                  </div>
                  <UserInfo 
                    :userId="item.regUserId" 
                    :userName="item.regUserName" 
                    :userNameEn="item.regUserNameEn"
                    :userCount="item.paperUserCount" 
                    :paperId="item.paperId" 
                  />
                </td>
                <td class="location">
                  <div class="multi-ellipsis"
                    @mouseover="mouseEvt(true, item, $event)"
                    @mouseleave="mouseEvt(false, item, null)"
                  >
                    {{ (item.groupKbn == 'CFRC' || item.groupKbn == 'SHAR') ? item.categoryName : item.location }}
                  </div>
                  <div class="tooltip-b tl small" :id="item.paperId+'_'+item.categoryMid+'_tooltip'" style="display:none; z-index: 10; position: absolute; word-break: break-all;">
                    {{ (item.groupKbn == 'CFRC' || item.groupKbn == 'SHAR') ? item.categoryName : item.location }}
                  </div>
                </td>
                <td class="txtc">
                  <button 
                    type="button" 
                    class="ico-switch_favorites small active" 
                    v-show="item.paperBookmarkId != null" 
                    @click="toggleBookmark(item)"
                  >
                    즐겨찾기
                  </button>
                  <button 
                    type="button" 
                    class="ico-switch_favorites small" 
                    v-show="item.paperBookmarkId == null"
                    @click="toggleBookmark(item)"
                  >
                    즐겨찾기
                  </button>
                </td>
                <td class="date txtc">
                  <!-- 24시간 이내-->
                  <momentAgo v-if="checkHours(item.lastUpdDate)" prefix="" suffix="전" :date="item.lastUpdDate" lang="kr"></momentAgo>
                  <!-- 24시간 이후-->
                  {{ !checkHours(item.lastUpdDate) ? item.lastUpdDate.substring(0,10).replace("-", ".").replace("-", ".") : '' }}
                  <span v-if="item.readCount == null || item.readCount == 0" class="ico-new"></span>
                </td>
                <td class="author txtc">
                  <div class="droplayer tooltipmember relative right">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">
                          <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.lastUpdUserName : item.lastUpdUserNameEn != null ? item.lastUpdUserNameEn : item.lastUpdUserName }}</b>
                        </v-btn>
                      </template>
                      <div class="dropdown-list">
                        <UserTooltip
                          :userId="item.lastUpdUserId"
                        />
                      </div>
                    </v-menu>
                  </div>
                </td>
                <td class="txtc">
                  <div class="droplayer icon more right nosel">
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                      </template>
                      <div class="dropdown-list">
                        <div class="dropdown-list-item"><div class="tit"><button type="button" @click="leavePaperUser(item)">{{ $i18nUtil.trans("button.paper.resign", "보드 탈퇴") }}</button></div></div>
                      </div>
                    </v-menu>
                  </div>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <div class="nodata-txt-noicon" v-if="boardList.length == 0 && !showSearchBoardTitle">
                <v-alert :value="true" v-if="isReadFilter || isBookmarkFilter">
                  {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                </v-alert>
                <v-alert :value="true" v-else>
                  {{ $i18nUtil.trans("search.009", "공유된 보드가 없습니다.") }}
                </v-alert>
              </div>
              <div class="nodata-txt-noicon" v-if="boardList.length == 0 && showSearchBoardTitle">
                <v-alert :value="true">
                  {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                </v-alert>
              </div>
            </template>
          </v-data-table>

          <div class="pagination">
            <v-pagination
              v-model="page"
              circle
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </div>
        </div>
      </div><!-- //tb-list_ty1 -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
import axios from "axios";
import Vue from 'vue';
import UserInfo from "@/components/cowork/common/user/UserInfo";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import CooperationMemberBoardFilter from "@/components/cowork/common/filter/CooperationMemberBoardFilter";

export default {
  components: {
    UserInfo,
    UserTooltip,
    CooperationMemberBoardFilter
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      showSearchBoardTitle: false,
      isBookmarkFilter: false,
      isReadFilter: false,
      searchPaperTitle: '',
      rtnSearchPaperTitle: '',
      isSearchArea: false,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.paper.filter.paperTitle","보드명"), align: 'center', value: 'paperTitle', sortable: true },
        { text: this.$i18nUtil.trans("entity.paper.filter.location","경로"), align: 'center', value: 'location', sortable: true},
        { text: this.$i18nUtil.trans("entity.paper.filter.paperBookmar","즐겨찾기"), value: 'paperBookmarkId', sortable: false },
        { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdate","마지막 업데이트"), value: 'lastUpdDate', sortable: true },
        { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUserName","생성/수정자"), value: 'lastUpdUserName', sortable: true},
        { text: this.$i18nUtil.trans("entity.paper.filter.more","더보기"), value: 'more', sortable: false },
      ],
      boardList: [],
      req: {},
      toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
            theme: "toasted-primary",
            position: "bottom-left",
            duration: 3000,
          },
      },
      ellipsisTimer: null,
      /* 정렬 */
      totalElements: 0,
      sortBy: ['lastUpdDate'],
      sortDesc: [true],
      /* 페이지 변경 또는 정렬 이벤트시 */
      changeTableData: false,
      filterReset: false,
      groupKbnList: [],
      // groupKbn: localStorage.getItem("groupKbn"),
      defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
    };
  },
  watch: {
    page: {
      handler() {
        if(this.changeTableData != true) {
          this.changeTableData = true;
        }
        window.scrollTo(0, 0);
      }
    },
    sortBy: {
      handler() {
        if(this.changeTableData != true) {
          this.changeTableData = true;
        }
      }
    },
    sortDesc: {
      handler() {
        if(this.changeTableData != true) {
          this.changeTableData = true;
        }
      }
    },
    changeTableData: {
      handler() {
        let obj = this;
        if(obj.changeTableData == true){
          setTimeout(()=>{
            obj.changeTableData = false; 
            obj.getCooperationMemberBoardList(false);
          }, 500);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.multiElipsis(2);
    const self = this;
    $("html").click(function (e) {
      if (!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
          self.isSearchArea = false;
      }
    });
    this.getCooperationMemberBoardList(false);

    // 뒤로가기 이벤트 발생시 .
    window.onpopstate = function (event) {
      let returnUrls = localStorage.getItem("returnUrls");
      if(returnUrls != null) {
        let urlList = returnUrls.split(",");
        if (urlList.length > 0) {
          if (urlList.length == 1) {
            localStorage.removeItem("returnUrls");
            // self.$router.push("/general/home");
          } else {
            urlList.pop();
            localStorage.setItem("returnUrls", urlList);
            // this.$router.replace(urlList[urlList.length-1]);
          }
        } else {
          self.$router.push("/general/home");
        }
      }else{
        self.$router.push("/general/home");
      }
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),

    /* 툴팁 */
    mouseEvt(flag, item, event) {
      let tooltipId = item.paperId+'_'+item.categoryMid+'_tooltip'
      if(flag) {
        // 말줄임(...) css 적용 여부 체크 (boolean)
        let val = this.$tooltip.hasOverflownHeightRemoveClass(event.target, "multi-ellipsis");
        if(val) {
          let width = event.target.getBoundingClientRect().width;
          document.getElementById(tooltipId).style.display = 'block';
          document.getElementById(tooltipId).style.width = width+'px';
        }else{
          document.getElementById(tooltipId).style.display = 'none';
        };
      }else{
        document.getElementById(tooltipId).style.display = 'none';
      }
    },
    /* 협업멤버 업무보드 리스트 조회 */
    getCooperationMemberBoardList(isSearch) {
      let obj = this;
      let pageParam = obj.page;
      if(isSearch == true) {
        if(obj.searchPaperTitle == '') {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB091", "검색어를 입력해주세요.");
          obj.showToast(obj.toastInfo);
          return;
        }
        pageParam = 1;
      }
      obj.showLoadingbar();
      obj.boardList = [];
      if(obj.searchPaperTitle != null && obj.searchPaperTitle != undefined && obj.searchPaperTitle.length > 0) {
        obj.showSearchBoardTitle = true;
      } else {
        obj.showSearchBoardTitle = false;
      }
      obj.rtnSearchPaperTitle = obj.searchPaperTitle;
      // if(obj.groupKbn != null){
      //   obj.groupKbnList.push(obj.groupKbn);
      //   obj.groupKbn = null;
      // }
      let param = {
        url: '/api/copaper/paper/getCooperationMemberBoardList',
        method: 'post',
        req: {
          searchPaperTitle: "%" + obj.searchPaperTitle + "%",
          limitRow: obj.itemsPerPage,
          page: pageParam - 1,
          sortKey: obj.sortBy[0],
          sortDesc: obj.sortDesc[0],
          isPaperBookmarkChecked: obj.isBookmarkFilter,
          isPaperReadChecked: obj.isReadFilter,
          groupKbnList: obj.groupKbnList
        }
      };
      obj.COWORK_REST_ACTION(param)
        .then(function (res) {
          if(res.errorCode == null) {
            obj.hideLoadingbar();
            obj.boardList = res.result.content;
            obj.totalElements = res.result.totalElements;
            obj.pageCount = res.result.totalPages;
          }
        })
        .catch(function (err) {
          obj.hideLoadingbar();
          console.log(err);
        });
    },
    /* 보드검색 초기화 */
    clearSearchPaperTitle() {
      let obj = this;
      obj.searchPaperTitle = '';
      obj.rtnSearchPaperTitle = '';
      obj.showSearchBoardTitle = false;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    /* 즐겨찾기 설정/해제 */
    toggleBookmark(board) {
      let obj = this;
      let reqData = {};
      reqData.params ={
        paperId: board.paperId,
        bookmarkId:board.paperBookmarkId
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/bookmark/savePaperBookmark";
      reqData.method = "post";
      // obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          board.paperBookmarkId = res.result;
          if(board.paperBookmarkId != null) {
            obj.toastInfo.message = obj.$i18nUtil.trans('TB041', '즐겨찾기가 설정되었습니다.');
            obj.showToast(obj.toastInfo);
          } 
          else {
            obj.toastInfo.message = obj.$i18nUtil.trans('TB042', '즐겨찾기가 해제되었습니다.');
            obj.showToast(obj.toastInfo);
          }
          // obj.hideLoadingbar();
          obj.changeTableData = true;
        }) 
        .catch(function(err) {
          obj.hideLoadingbar();
          console.log(err);
        });
    },
    /* 미확인보드 필터 */
    fireFilterRead(){
      let obj = this;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    /* 즐겨찾기 필터 */
    fireFilterBookmark(){
      let obj = this;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    /* 보드 상세화면 이동 */
    goBoard(paperId) {
      this.$router.push('/general/board/'+paperId)
    },
    /* 상세옵션 정보 */
    getEvaluateClassAndText(board) {
      let rtnEvaluateJson = {evaluateClass: '', evaluateText: ''};
      // exceeded
      if(board.paperStatus == 'GOOD') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-good";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상");
      }
      // on track
      else if(board.paperStatus == 'SO') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-so";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생");
      }
      // at risk
      else if(board.paperStatus == 'DELAY') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-delay";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요");
      }
      // off track
      else if(board.paperStatus == 'EXCEEDED') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-exceeded";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료");
      }
      return rtnEvaluateJson;
    },
    /* 시간체크 */
    checkHours(lastUpdated) {
      let now = this.$moment()
      let before24hours = this.$moment().subtract(1,'days')
      let lastUpdatedTime = this.$moment(lastUpdated)
      
      if(lastUpdatedTime.isBetween(before24hours, now)) {
        // 24시간 이내
        return true;
      }else{
        // 24시간 이후
        return false;
      }
    },
    addBoard(item) {
      let obj = this;
      let reqData = {};
      reqData.params ={
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/getGeneratedPaperId";
      reqData.method = "post";
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          let errorCode = res.errorCode;
          let addPaperId = res.result;
          const modalInfo = {
            title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
            name: "registBoard",
            method: "post",
            width: "800px",
            // height: "493px",
            obj: obj.$modal,
            paperId: addPaperId, 
            categoryMid: null,
            groupId:  null, 
            projectId: null,
            paperTitle: "",
            contentPath: "",
            component: RegistBoardModal,
            shareType: null,
            parentCategoryMid: null,
          };
          // console.log(modalInfo);
          obj.hideLoadingbar();
          obj.showModal(modalInfo);
        })
        .catch(function(err) {
          obj.hideLoadingbar();
          console.log(err);
        });
    },
    /* 보드 생성 API 호출 */
    registBoard(_data) {
      let paramJSON = {
        paperTitle : _data.paperTitle, 
        paperId: _data.paperId, 
        groupId : _data.groupId, 
        categoryMid : _data.categoryMid, 
        contentPath : _data.contentPath, 
        docGrade: "NORMAL", 
        blockType: "CONTENT",
        link:"/general/board/" + _data.paperId,
      };
      this.showLoadingbar();
	    axios.post("/api/copaper/paper/addPaper", paramJSON)
        .then(res => { 
          this.hideLoadingbar();
          this.toastInfo.message = this.$i18nUtil.trans("TB064", "과제 멤버로 추가되었습니다.");
          this.showToast(this.toastInfo);
          let newBoard = JSON.parse(res.config.data)
          newBoard = newBoard.paperId
          this.$router.push('/general/board/'+newBoard);
        })
        .catch(err => {console.log(err);});
    },
    /* 보드탈퇴 */
    leavePaperUser(paperItem) {
      let obj = this;
      let confirmParam = {
        confirmMessage: obj.$i18nUtil.trans('AB019', '탈퇴 시 다시 접근할 수 없으며 연결된 모든 접근 권한도 사라지게 됩니다. 탈퇴하시겠습니까?'),
        confirmBtnText: obj.$i18nUtil.trans("button.resign", "탈퇴"),
        confirmBtnCallback: obj.leavePaperUserCall,
        modalParam: {paperItem: paperItem, targetName: paperItem.paperTitle},
        cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
      };
      obj.showConfirmDialogWithJSON(confirmParam);
      
    },
    /* 보드탈퇴 API 호출 */
    leavePaperUserCall(callbackData) {
      let url = "/api/copaper/paperuser/deletePaperUser";
      let param = {};
      param = {
        paperId: callbackData.modalParam.paperItem.paperId,
        userId: callbackData.modalParam.paperItem.paperUserId
      };
      let obj = this;
      obj.showLoadingbar();
      axios
        .post(url, param)
        .then(res => {
          obj.hideLoadingbar();
          if (res.data.errorCode != null) {
            return;
          }
          obj.toastInfo.message = obj.$i18nUtil.trans('TB025', '[{targetName}]에서 탈퇴되었습니다.', {targetName: callbackData.modalParam.targetName});
          obj.showToast(obj.toastInfo);
          obj.getCooperationMemberBoardList(false);
        })
        .catch(err => {
          obj.hideLoadingbar();
          console.log("axios err => ", err);
        });

    },
    multiElipsis(ellipsisLine) {
      if (this.ellipsisTimer) {
        clearTimeout(this.ellipsisTimer);
      }

      this.ellipsisTimer = setTimeout(function () {
        if ($(".multi-ellipsis").length > 0) {
          var omle = $(".multi-ellipsis");
          var $txtR = $("<div class='txtEllipsis'></div>");
          var $body = $("body");
          omle.each(function (idx) {
            var _this = $(this);
            var orinalWidth = $(this).width();
            var txtOmle = _this.text();

            $txtR.text(txtOmle);
            $body.append($txtR);

            if ($txtR.width() >= orinalWidth * 1.2) {
              _this.addClass("no-ellipsis");
            } else {
              _this.removeClass("no-ellipsis");
            }
          });
        }
      }, 250);

      setTimeout(function () {
        $(".txtEllipsis").remove();
      }, 1000);
    },
    updateCooperationMemberBoardFilter(filterData) {
      let obj = this;
      obj.groupKbnList = filterData.filterGroupKbnList;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    }
  },
};
</script>

<style scoped>
.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  min-height: 23px;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/cooperationMember/CooperationMemberBoard.vue